<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <!-- Form Structure -->
        <form @submit.prevent="sendData(formaction)" aria-describedby="Create Content Default" class="form-contentdefault" action="" method="" enctype="multipart/form-data" autocomplete="on">
            
            <!---Layout Structure-->
            <fieldset class="d-flex flex-column mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Layout Setup</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>

                <div class="fieldsetcontent d-none">

                    <div class="d-flex flex-row justify-content-between my-4">

                        <!--Layout-->
                        <fieldset class="layout order-1 d-flex flex-column">

                            <!-- Website Layout -->
                            <div class="order-1 mb-3">

                                <legend>Choose your Layout</legend>

                                <div class="my-2 layoutbase">
            
                                    <div v-if="Object.values(layoutlist).length > 0" id="layoutinput" class="mb-3 layoutinput" data-inputorder="1">
            
                                        <select class="form-select layoutselectlist" aria-label="Choose your Layout" ref="layoutselectlist">
            
                                            <!-- Default Option Selected -->
                                            <option v-if="formaction === 'insert'" selected>Choose your Layout</option>
            
                                            <!-- Layout Update Routine -->
                                            <option 
                                                v-for="(value, index) in layoutlist" 
                                                :key="value.id" 
                                                :data-layoutid="value.id"
                                                :data-filename="value.data.filenamenew"  
                                                :data-referindex="index" 
                                                :value="value.id"
                                                :data-selected="value.active"
                                                :selected="parseInt(value.active)"
                                                >
                                                {{ value.name }}
                                            </option>
                                        
                                        </select>
            
                                    </div>
            
                                    <template v-else>
            
                                        <span>It is necessary actived the layout list</span>
            
                                    </template>
            
                                </div>

                            </div>
                        
                            <!-- Preview Layout -->
                            <div class="order-2">

                                <legend>Choose your Preview Layout</legend>

                                <div class="my-2 previewlayoutbase">
            
                                    <div v-if="Object.values(layoutlist).length > 0" id="previewlayoutinput" class="mb-3 previewlayoutinput" data-inputorder="2">
            
                                        <select 
                                            class="form-select layoutselectlist previewlayoutselectlist" 
                                            aria-label="Choose your Layout" 
                                            ref="layoutselectlistpreview"
                                            id="previewlayoutselectlist"
                                            @change="setPreviewLayout($event)"
                                        >
            
                                            <!-- Default Option Selected -->
                                            <option v-if="formaction === 'insert'" selected>Choose your Layout</option>
            
                                            <!-- Layout Update Routine -->
                                            <option 
                                                v-for="(value, index) in layoutlist" 
                                                :key="value.id" 
                                                :data-layoutid="value.id"
                                                :data-filename="value.data.filenamenew"  
                                                :data-referindex="index" 
                                                :value="value.id"
                                                :data-selected="value.active"
                                                :selected="parseInt(value.active)"
                                                >
                                                {{ value.name }}
                                            </option>
                                        
                                        </select>
            
                                    </div>
            
                                    <template v-else>
            
                                        <span>It is necessary actived the layout list</span>
            
                                    </template>
            
                                </div>

                            </div>

                        </fieldset>

                        <!-- Upload File -->
                        <fieldset class="layoutfile order-2">

                            <legend>Upload your Style Design CSS File</legend>

                            <input @change="styleFileData($event)" class="form-control layoutfile my-2" name="layoutfile" type="file" id="layoutfile" accept=".css, .min.css">

                        </fieldset>

                        <!--HeaderLayout-->
                        <fieldset class="headerlayout order-3">

                            <legend>Choose your Navmenu Header</legend>

                            <div class="my-2 headerlayoutbase">

                                <div v-if="Object.values(headerlayoutlist).length > 0" id="headerlayoutinput" class="mb-3 headerlayoutinput" data-inputorder="1">

                                    <select class="form-select headerlayoutselectlist" aria-label="Choose your Navmenu Header Layout">

                                        <!-- Default Option Selected -->
                                        <option v-if="formaction === 'insert'" selected>Choose your Navmenu Layout</option>

                                        <!-- Layout Update Routine -->
                                        <option 
                                            v-for="(val, index) in headerlayoutlist" 
                                            :key="val.id" 
                                            :data-headerid="val.id" 
                                            :data-referindex="index" 
                                            :value="val.id"
                                            :data-selected="val.active"
                                            :selected="parseInt(val.active)"
                                            @click="activeSelectList($event, headerlayoutlist)"
                                            >
                                            {{ val.name }}
                                        </option>
                                    
                                    </select>

                                </div>

                                <template v-else>

                                    <span>It is necessary actived the navmenu header layout list</span>

                                </template>

                            </div>

                        </fieldset>

                    </div>

                </div>

            </fieldset>

            <!---Logotipo Structure-->
            <fieldset class="logotipo mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Logotipo</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>

                <div class="fieldsetcontent d-none">

                    <div class="my-4">

                        <div class="mb-3 logotipoinputalt logotipoinput d-none" data-inputorder="1">
                            <label for="filealt" class="form-label">File Info</label>
                            <input type="text" name="filealt" v-model="filealt" class="form-control filealt" id="filealt" placeholder="Please inform the alt for the file">
                        </div>
        
                        <div class="mb-3 logotipoinput" data-inputorder="2">
                            <div class="d-flex flex-row justify-content-start mb-3">
                                <label for="file" class="form-label order-1">File</label>
                                <button type="button" class="btn btn-primary btnaddimage order-2 ms-3" @click="showModal('insertmedia')">Add</button>
                                <button type="button" class="btn btn-secondary btnselectimage order-3 ms-3" @click="showModal('baseselectimage')">Images</button>
                            </div>
                            <input @change="fileData($event)" class="form-control file" name="file" type="file" id="file" accept="image/*" ref="inputfile">
                        </div>

                    </div>

                </div>

            </fieldset>

            <!---Social Media Structure-->
            <fieldset class="socialmedia mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Social Media</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>

                <div class="fieldsetcontent d-none">

                    <div class="my-4 socialmediabase" @click="removeDivBaseInput($event)">

                        <div class="mb-3 socialmediainput" data-inputorder="1">
                            <label for="linkedin" class="form-label">Linkedin</label>
                            <input type="text" name="socialmedia1" v-model="socialmedia1" class="form-control" id="linkedin" placeholder="Please inform the url" value="">
                        </div>
        
                        <div class="mb-3 socialmediainput" data-inputorder="2">
                            <label for="facebook" class="form-label">Facebook</label>
                            <input type="text" name="socialmedia2" v-model="socialmedia2" class="form-control" id="facebook" placeholder="Please inform the url" value="">
                        </div>
        
                        <div class="d-flex flex-row justify-content-between">
    
                            <button type="button" class="btn btn-primary" @click="addInput('.socialmediabase')">Add</button>
    
                            <template v-if="computedInputsDivs.length > 0">
    
                                <button type="button" class="btn btn-danger ml-3" @click="removeAllInputs">Remove All</button>
    
                            </template>
    
                        </div>
    
                    </div>

                </div>

            </fieldset>

            <!---Contacts Structure-->
            <fieldset class="contatos mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Contatos</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>
               
                <div class="fieldsetcontent d-none">

                    <div class="my-4 contactbase">

                        <div class="mb-3 contactinput" data-inputorder="1">
                            <label for="morada" class="form-label">Morada</label>
                            <input type="text" name="morada" v-model="address" class="form-control" id="morada" placeholder="Please inform the address">
                        </div>
    
                        <div class="d-flex flex-row justify-content-between">
    
                            <div class="mb-3 contactinput col-5 p-0 m-0" data-inputorder="2">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" name="email" v-model="email" class="form-control" id="email" placeholder="Please inform the email">
                            </div>
    
                            <div class="mb-3 contactinput col-5 p-0 m-0" data-inputorder="3">
                                <label for="phone" class="form-label">Phone</label>
                                <input type="text" name="phone" v-model="phone" class="form-control" id="phone" placeholder="Please inform the phone">
                            </div>
    
                        </div>
    
                        <div class="mb-3 contactinput" data-inputorder="4">
                            <label for="funcionamento" class="form-label">Funcionamento</label>
                            <textarea class="form-control" name="funcionamento" id="funcionamento" aria-label="funcionamento textarea" placeholder="Please inform the operation">
                                {{ funcionamento ? funcionamento.trim() : '' }}
                            </textarea>
                        </div>
    
                    </div>

                </div>
            
            </fieldset>

            <!---Location Structure | Google Maps-->
            <fieldset class="googlemaps mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Google Maps</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>

                <div class="fieldsetcontent d-none">

                    <div class="d-flex flex-row justify-content-between my-4">

                        <div class="googlemapsinput col-4 p-0 m-0" data-inputorder="1">
                            <label for="latitude" class="form-label">Latitude</label>
                            <input type="text" name="latitude" v-model="latitude" class="form-control" id="latitude" placeholder="Please inform the Latitude">
                        </div>
    
                        <div class="googlemapsinput col-4 p-0 m-0" data-inputorder="2">
                            <label for="longetutide" class="form-label">Longetutide</label>
                            <input type="text" name="longetutide" v-model="longetutide" class="form-control" id="longetutide" placeholder="Please inform the Longetutide">
                        </div>
    
                        <div class="googlemapsinput col-2 p-0 m-0" data-inputorder="3">
                            <label for="zoommap" class="form-label">Zoom</label>
                            <input type="text" name="zoommap" v-model="zoommap" class="form-control" id="zoommap" placeholder="Please inform the Zoom">
                        </div>
    
                    </div>

                </div>
              
            </fieldset>
            
            <!--- Google Tag -->
            <fieldset class="googletag mb-3">

                <header class="d-flex flex-row justify-content-between">

                    <div class="legendbase order-1">
                        <legend>Google Tag</legend>
                    </div>

                    <div class="baseaction order-2">
                        <button type="button" class="btn btn-dark" @click="showFieldsetContent($event)">Show</button>
                    </div>
                    
                </header>

                <div class="fieldsetcontent d-none">

                    <div class="d-flex flex-row justify-content-between my-4">

                       <!--  <div class="mb-3 googletaginput" data-inputorder="1">
                            <label for="googletag_script" class="form-label">Add Google tag</label>
                            <pre id="googletag_script">
                                <code class="googletag_data" aria-label="Google Tag Script" contenteditable="true" ref="googletag_data">
                                </code>
                            </pre>
                        </div> -->

                        <div class="googletaginput col-12 p-0 m-0" data-inputorder="1">
                            <label for="googletag_script" class="form-label">Add Google tag</label>
                            <input type="text" name="googletag_script" aria-label="Google Tag Script" v-model="googletagcode" class="form-control" id="googletag_script" placeholder="Please inform your Google id code">
                        </div>
    
                    </div>

                </div>
              
            </fieldset>

            <button type="submit" class="btn btn-primary float-end my-3" :disabled="disabled">{{ btntext }}</button>

        </form>

        <!-- Modal for Select Image -->
        <modal
            title="Select Image"
            classname="baseselectimage"
        >

            <template #modalcontent>

                <!-- Media List -->
                <media-list
                    :allmediafiles="allmediafiles"
                    @choose-image="chooseImage($event)"
                />

            </template>

        </modal>

        <!-- Modal for Insert Media -->
        <modal
            title="Insert Media"
            classname="insertmedia"
        >

            <template #modalcontent>

                <!-- Insert Media Element -->
                <insert-media 
                    :csrftolken="csrftolken"
                    :mediainsert="mediainsert"
                    modalclassname="insertmedia"
                    responseclassname="responsebasemessage"
                    :removeresponsemessages="removeResponseMessages"
                    :checklocalstorage="checkLocalStorage"
                />

            </template>

        </modal>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>

</template>
<script>
    import store from '../../store/index.js';
    import Modal from './../elements/ModalElement.vue';
    import MediaList from './../elements/MediaListElement.vue';
    import fetchData from './../../fetchData.js';
    import htmlElements from './../../htmlElements.js';
    import validation from './../../inputValidation.js';
    import ListMessage from './../elements/ListMessageElement.vue';
    import Loading from './../elements/LoadingElement.vue';
    import InsertMedia from './../elements/MediaInsertElement.vue';

    //Set Use Strict
    "use strict";

    export default{
        name: 'ContentDefault',
        props:{

            csrftolken:{
                type: String,
                required: true
            },
            contentcreate:{
                type: String,
                required: true
            },
            allcontent:{
                type: String,
                required: true
            },
            imagestoragepath:{
                type: String,
                required: true
            },
            contentupdate:{
                type: String,
                required: true
            },
            alllayout:{
                type: String,
                required: true
            },
            layoutfile:{
                type: String,
                required: true
            },
            previewlayout:{
                type: String,
                required: true
            },
            mediainsert:{
                type: String,
                required: true
            },

        },
        data: () => {

            return{

                counter: 2,
                file: '',
                inputsdivs: [],
                alertgigabyte: 1024 * 1024 * 1000 * 2,
                disabled: false,
                filedataform: {},
                formaction: '',
                alldata: {},
                activeclass: 'd-flex',
                getDataValue: [],
                getReferInputName: [],
                address: '',
                email: '',
                phone: '',
                funcionamento: '',
                socialmendiamodel: ['socialmedia1', 'socialmedia2'],
                socialmedia1: '',
                socialmedia2: '',
                btntext: '',
                filewidth: '',
                fileheight: '',
                filealt: '',
                layoutlist: {},
                activelayoutid: '',
                allmediafiles: {},
                filedataformlist: [],
                allmediafileslocalstorage: {},
                headerlayoutlist: [
                    {
                        id: 1,
                        name: 'Header 1',
                        classname: ["navbar", "navbar-expand-lg"],
                        active: 0
                    },
                    {
                        id: 2,
                        name: 'Header 2',
                        classname: ["navbar", "navbar-expand-lg", "navbar-light", "bg-light"],
                        active: 0
                    },
                    {
                        id: 3,
                        name: 'Header 3',
                        classname: ["navbar", "navbar-expand-sm"],
                        active: 1
                    }
                ],
                activeheaderlayoutid: '',
                latitude: '',
                longetutide: '',
                zoommap: '',
                stylefiledataform: {},
                googletagcode: '',

            }

        },
        created(){

            //Get All Media Data
            this.checkLocalStorage();

            //Set Data from DB
            this.alldata = JSON.parse(this.allcontent);

            //Set Layout List
            this.layoutlist = JSON.parse(this.alllayout);

            //Set formaction
            this.formaction = this.alldata.length === 0 ? 'insert' : 'update';

            //Set Btn Text
            this.btntext = this.alldata.length === 0 ? 'Submit' : 'Update';

            //Set Active Layout Id
            let layoutitem = this.layoutlist.find(value => parseInt(value.active) === 1);
            this.activelayoutid = layoutitem.id;

            //Set Active Layout Id
            if(this.formaction === 'insert'){

                let headerlayoutitem = this.headerlayoutlist.find(val => parseInt(val.active) === 1);
                this.activeheaderlayoutid = headerlayoutitem.id;

            }
            
            //console.log(this.alldata);
            //console.log(this.setInputData('.logotipoinput', this.alldata[0]));
            

        },
        beforeMount(){

            

        },
        mounted(){

            //Check if exist old data
            if(this.alldata.length > 0){

                //Set Input Data
                this.addDataForSetInputData();

            }

        },
        methods:{

            showFieldsetContent(element){

                //Get Fieldsetcontent
                let fieldsetcontent = element.currentTarget.parentElement.parentElement.nextElementSibling;

                //Check Class
                if(fieldsetcontent.classList.contains('d-none')){

                    //Remove Class
                    fieldsetcontent.classList.remove('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Hide';

                }else{


                    //Add Class
                    fieldsetcontent.classList.add('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Show';

                }

            },
            setPreviewLayout(element){

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Disabled Element
                this.$refs.layoutselectlistpreview.setAttribute('disabled', true);

                //Get Data for Submit - Layout
                let previewlayout = {
                    name: "preview_layout",
                    value: parseInt(element.currentTarget.value.trim())
                };

                //Set layout Data
                let layoutSelected = this.layoutlist.find(value => parseInt(value.id) === parseInt(previewlayout.value));
                previewlayout.layoutname = layoutSelected.name;
                previewlayout.filenamenew = layoutSelected.data.filenamenew;

                //Send Style FileData
                let response = fetchData.structureTosendData(this.previewlayout, previewlayout, this.csrftolken, 'POST');
                    
                //Check Response
                response.then((value) => {

                    //Enabled Element
                    this.$refs.layoutselectlistpreview.removeAttribute('disabled');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Check Error Message
                    if(value.hasOwnProperty('errorMessage') ||
                    value.hasOwnProperty('successMessage')
                    ){

                        //Set Object Keys
                        let key = Object.keys(value);

                        //Add active Class
                        this.$refs.responsebasemessage.classList.add(this.activeclass);
                        this.$refs.responsebasemessage.classList.add(key[0].toLowerCase());

                        //Get Values from Object
                        let message = Object.values(value);

                        //===> Set Messages List
                        //Element for append
                        let li = `<li class="list-group item my-1">${message[0]}</li>`;

                        //Append Element
                        $(li).appendTo(this.$refs.responsebasemessage.children);

                        //Remove Base Response Message
                        this.removeResponseMessages();

                        return;

                    }

                }).catch((error) => {

                    //Enabled Element
                    this.$refs.layoutselectlistpreview.removeAttribute('disabled');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    throw new Error(error);

                });

            },
            activeSelectList(element, selectlist){

                //Select Iten
                let selectItem = Number.isInteger(element) ? element : element.target.getAttribute('data-headerid');

                //Change Active select item
                selectlist.map((value) => {

                    if(parseInt(selectItem) === parseInt(value.id)){

                        value.active = 1;

                    }else{

                        value.active = 0;

                    }

                });
                
                return selectlist;

            },
            checkLocalStorage(){

                //Set All Media
                this.allmediafileslocalstorage = localStorage.getItem('logotipolist');

                //Check Allmedia Files LocalStorage
                if(this.allmediafileslocalstorage){

                    this.allmediafiles = JSON.parse(this.allmediafileslocalstorage);

                }

                return this.allmediafiles;

            },
            chooseImageFiledata(element){

                //Get Filedata from select image
                let filedata = {
                    id: document.querySelector('.logotipo').getAttribute('data-idcolumn'),
                    fileaction: 'select',
                    imageid: element.target.getAttribute('data-fileid'),
                    filealt: element.target.getAttribute('data-filealt'), 
                    fileext: element.target.getAttribute('data-fileext'), 
                    filenamenew: element.target.getAttribute('data-filenamenew'), 
                    filenameold: element.target.getAttribute('data-filenameold')
                };

                //Set Relation with sectionid and image filedata this.filedataformlist
                Object.assign(this.filedataform, filedata);

                //Check Element
                if(document.querySelector('.logotiposhowimg')){

                    document.querySelector('.logotiposhowimg').setAttribute('src', element.target.getAttribute('src'));

                }

                return this.filedataform;

            },
            chooseImage(element){

                //List All Images
                let mediaImageList = [...document.querySelectorAll('.media-image')];
                        
                //Remove class
                mediaImageList.forEach((valimg) => {

                    //Check Active Class
                    if(valimg.getAttribute('data-fileid') !== this.filedataform.inputid &&
                    valimg.classList.contains('select-image')){

                        valimg.classList.remove('select-image');

                    }

                });

                //Add Class 
                element.target.classList.add('select-image');

                //Clean Variable
                this.filedataform = {};

                //Set FileData from Select Imnage
                this.chooseImageFiledata(element);

                //Enabled Button
                this.disabled = false;

                //Closed Model
                this.hideModal('baseselectimage');

            },
            showModal(classname){

                //Show Modal
                $(`.${classname}`).modal("show");

                return;

            },
            hideModal(classname){

                //Hide Modal
                $(`.${classname}`).modal("hide");

            },
            addDataForSetInputData(attactivelayout = false){

                //Set Content Default
                let logotipodata = this.alldata.find(value => value.type === 'logotipo');
                let socialmediadata = this.alldata.find(value => value.type === 'socialmedia');
                let contactsdata = this.alldata.find(value => value.type === 'contacts');
                let layoutdata = this.alldata.find(value => value.type === 'layout');
                let headerlayoutdata = this.alldata.find(value => value.type === 'headerlayout');
                let googlemapsdata = this.alldata.find(value => value.type === 'googlemaps');
                let googletagdata = this.alldata.find(value => value.type === 'googletag');

                //Render InputData
                let allDataForInput = [logotipodata, socialmediadata, contactsdata, layoutdata, headerlayoutdata, googlemapsdata, googletagdata];

                allDataForInput.forEach((value) => {

                    //Check ObjectData
                    if(value !== undefined){

                        switch(value.type){

                            //Logotipo
                            case 'logotipo':
                            case 'socialmedia':
                            case 'layout':
                            case 'headerlayout': 
                            case 'googlemaps':
                            case 'googletag':       

                                //Set Dynamic Counter for socialmedia
                                if(value.type === 'socialmedia'){

                                    //Set default value
                                    this.counter = 2;

                                    //Remove all old elements from socialmedia inputs
                                    this.removeAllInputs();

                                }

                                //Set Active Layout Id
                                if(value.type === 'layout' && this.formaction === 'update' && attactivelayout){

                                    //Set Layout Data
                                    let layoutvalue = JSON.parse(value.data);

                                    //Set Active Layout Id
                                    this.activelayoutid = layoutvalue !== null ?  layoutvalue.value.layoutid : this.activelayoutid;

                                }

                                //Set Active Layout Id
                                if(value.type === 'headerlayout' && this.formaction === 'update' /* && attactivelayout */){

                                    //Set Layout Data
                                    let layoutvalue = JSON.parse(value.data);

                                    //Set Active Layout Id
                                    this.activeheaderlayoutid = layoutvalue !== null ? layoutvalue.value.id : this.activeheaderlayoutid;

                                    //Change Active Select Item
                                    this.activeSelectList(parseInt(this.activeheaderlayoutid), this.headerlayoutlist);

                                }

                                //Check when the data is not null
                                if(value.data !== null){

                                    this.setInputData(`.${value.type}input`, value);

                                }else{

                                    //Add Id Column
                                    if(this.formaction === 'update'){

                                        switch(value.type){

                                            case 'logotipo':

                                                //Set Id column and type
                                                document.querySelector('.btnselectimage').setAttribute('data-idcolumn', value.id);
                                                document.querySelector('.btnselectimage').setAttribute('data-typecolumn', value.type);
                                                document.querySelector('.logotipo').setAttribute('data-idcolumn', value.id);
                                                document.querySelector('.logotipo').setAttribute('data-typecolumn', value.type);

                                            break;

                                            case 'socialmedia':
                                            case 'layout':
                                            case 'headerlayout':
                                            case 'googlemaps':
                                            case 'googletag':                

                                                //Set Id column and type
                                                document.querySelector(`.${value.type}`).setAttribute('data-idcolumn', value.id);
                                                document.querySelector(`.${value.type}`).setAttribute('data-typecolumn', value.type);

                                            break;

                                        }

                                    }

                                }
                                

                            break;

                            //contacts
                            case 'contacts':
                            case 'contact':
                                
                                //Check when the data is not null
                                if(value.data !== null){

                                    this.setInputData('.contactinput', value);

                                }else{

                                    //Add Id Column
                                    if(this.formaction === 'update'){

                                        //Set Id column and type
                                        document.querySelector('.contatos').setAttribute('data-idcolumn', value.id);
                                        document.querySelector('.contatos').setAttribute('data-typecolumn', value.type);

                                    }    

                                }

                            break;

                        }

                    }

                });

            },
            setInputData(classname, getdata){

                //Parse Value
                let contentdata = JSON.parse(getdata.data);

                //Set Data for inputs
                switch(classname)
                {

                    case '.logotipoinput':

                        //Check value
                        if(getdata.data !== null || getdata.data){

                            //Get Data from Inputs
                            let allInputs = [...document.querySelectorAll(classname)];

                            //Get only Values for Inputs
                            allInputs.forEach((valelement, index) => {

                                let elementchildrens = [...valelement.children];

                                //Set Data for children elements
                                elementchildrens.forEach((valchildren) => {

                                    //Check FileAlt
                                    if(valchildren.nodeName === 'INPUT' && valchildren.getAttribute('name') === 'filealt'){

                                        //Set Old Data for filealt
                                        this.filealt = contentdata.filealt;

                                        //Show File Alt
                                        document.querySelector('.logotipoinputalt').classList.remove('d-none');

                                        //Set Read Only
                                        document.getElementById('filealt').setAttribute('readonly', true);

                                    }

                                    //Check Element
                                    if(valchildren.nodeName === 'INPUT' && valchildren.getAttribute('name') === 'file'){

                                        //Set Image for view
                                        if(contentdata.hasOwnProperty('filenamenew')){

                                            //Create Element
                                            let img = document.createElement('img');

                                            //Set Attribute
                                            img.setAttribute('src', this.imagestoragepath + '/logo/' + contentdata.filenamenew);
                                            img.setAttribute('width', '190');
                                            img.setAttribute('height', '90');
                                            img.setAttribute('alt', contentdata.filenameold);
                                            img.setAttribute('data-filenamenew', contentdata.filenamenew);
                                            img.setAttribute('data-filenameold', contentdata.filenameold);
                                            img.setAttribute('data-fileext', contentdata.fileext);
                                            img.setAttribute('data-imageid', getdata.image_id);
                                            img.setAttribute('class', 'logotiposhowimg');

                                            //Append Data
                                            valchildren.after(img);

                                        }

                                    }

                                });

                            });

                            document.querySelector('.btnselectimage').setAttribute('data-storagefile', contentdata.filenamenew);
                            document.querySelector('.logotipo').setAttribute('data-storagefile', contentdata.filenamenew);

                        }

                        //Check ImageId
                        if(getdata.image_id !== null){

                            document.querySelector('.btnselectimage').setAttribute('data-imageid', getdata.image_id);
                            document.querySelector('.logotipo').setAttribute('data-imageid', getdata.image_id);

                        }


                        //Set Id column and type
                        document.querySelector('.btnselectimage').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.btnselectimage').setAttribute('data-typecolumn', getdata.type);
                        document.querySelector('.logotipo').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.logotipo').setAttribute('data-typecolumn', getdata.type);
                        
                    break;

                    case '.socialmediainput':

                        //Default input socialmedia1
                        this.getDataValue = contentdata.find((value) => value.name === this.socialmendiamodel[0]);
                        this.socialmedia1 = this.getDataValue.value;

                        //Default input socialmedia2
                        this.getDataValue = contentdata.find((value) => value.name === this.socialmendiamodel[1]);
                        this.socialmedia2 = this.getDataValue.value;

                        //console.log(contentdata);

                        //Default Input
                        if(contentdata.length >= 3){

                            //Clean data
                            this.getDataValue = [];

                            //Set Counter
                            this.counter = contentdata.length;

                            //Filter Nputs  
                            this.getDataValue = contentdata.filter((valcontent) => !this.socialmendiamodel.includes(valcontent.name));

                            //console.log('Aqui');
                            //console.log(this.getDataValue);

                            //Render Dynamic Input
                            this.getDataValue.forEach((valcontent) => {

                                //Create Input
                                this.addInput('.socialmediabase', valcontent.value);

                            });
                           
                        }
                        
                        //Set Id column and type
                        document.querySelector('.socialmedia').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.socialmedia').setAttribute('data-typecolumn', getdata.type);

                    break;

                    case '.contactinput':

                        this.getDataValue = contentdata.filter((value) => value.name === 'morada');
                        this.address = this.getDataValue.length > 0 ? this.getDataValue[0].value : '';

                        this.getDataValue = contentdata.filter((value) => value.name === 'email');
                        this.email = this.getDataValue.length > 0 ? this.getDataValue[0].value : '';

                        this.getDataValue = contentdata.filter((value) => value.name === 'phone');
                        this.phone = this.getDataValue.length > 0 ? this.getDataValue[0].value : '';

                        this.getDataValue = contentdata.filter((value) => value.name === 'funcionamento');
                        this.funcionamento = this.getDataValue.length > 0 ? this.getDataValue[0].value : '';

                        //Set Id column and type
                        document.querySelector('.contatos').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.contatos').setAttribute('data-typecolumn', getdata.type);


                    break;

                    case '.layoutinput':

                        //Set Id column and type
                        document.querySelector('.layout').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.layout').setAttribute('data-typecolumn', getdata.type);

                    break;

                    case '.headerlayoutinput':

                        //Set Id column and type
                        document.querySelector('.headerlayout').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.headerlayout').setAttribute('data-typecolumn', getdata.type);

                    break;

                    case '.googlemapsinput':

                        //Default input latitude
                        this.getDataValue = contentdata.find((value) => value.name === 'latitude');
                        this.latitude = this.getDataValue.value;

                        //Default input longetutide
                        this.getDataValue = contentdata.find((value) => value.name === 'longetutide');
                        this.longetutide = this.getDataValue.value;

                        //Default input zoommap
                        this.getDataValue = contentdata.find((value) => value.name === 'zoommap');
                        this.zoommap = this.getDataValue.value;

                        //Set Id column and type
                        document.querySelector('.googlemaps').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.googlemaps').setAttribute('data-typecolumn', getdata.type);

                    break;

                    case '.googletaginput':
                        
                        //Set Id column and type
                        document.querySelector('.googletag').setAttribute('data-idcolumn', getdata.id);
                        document.querySelector('.googletag').setAttribute('data-typecolumn', getdata.type);

                        //Set Data
                        //this.$refs.googletag_data.textContent = contentdata;
                        this.googletagcode = contentdata;

                    break;
                    
                }
                

            },
            addInput(classbasename, inputvalue = ''){

                //Increment Value
                this.counter++;

                //Set Inputid - name - class
                let inputrefer = `socialmedia${this.counter}`;

                //Set DivBase Input refer
                let divbaserefer = `socialmediainput${this.counter}`;

                //Div Element
                let div = htmlElements.createElement('div',  {
                    class: `mt-3 socialmediainput ${divbaserefer}`,
                    data_inputorder: this.counter
                });

                //Append Child - basediv
                document.querySelector(classbasename).appendChild(div);

                //Label Element
                let label = htmlElements.createElement('label',  {
                    class: 'form-label',
                    for: inputrefer
                }, `Social Media ${this.counter}`);
             
                //Append Label
                document.querySelector('.' + divbaserefer).appendChild(label);

                //Input Element
                let input = htmlElements.createElement('input',  {
                    type: 'text',
                    class: `form-control ${inputrefer}`,
                    id: inputrefer,
                    placeholder: 'Please inform the url',
                    name: inputrefer,
                    value: inputvalue
                }, `Social Media ${this.counter}`);

                //Append Input
                document.querySelector('.' + divbaserefer).appendChild(input);

                //Button Element
                let button = htmlElements.createElement('button',  {
                    type: 'button',
                    class: 'btn btn-danger',
                    data_refer: divbaserefer
                }, 'Remove');

                //Append Button
                document.querySelector('.' + divbaserefer).appendChild(button);

                //Set input list Divs
                this.inputsdivs = [...document.querySelectorAll('.socialmediainput')];

            },
            removeDivBaseInput(element){

                //Get Element Data
                let el = element.target;

                //Check Element
                if(el.nodeName === 'BUTTON' && el.hasAttribute('data-refer')){

                    //Decrement Value
                    this.counter--;

                    //Get Div Refer
                    let div = el.getAttribute('data-refer');

                    //Remove Element
                    document.querySelector(`.${div}`).remove();

                }

                return;

            },
            removeAllInputs(){

                //No Remove Inputs
                let noRemove = ["1", "2"];

                //Remove All inputs clone
                this.inputsdivs.filter((value, index) => {

                    //Check for the originals inputs
                    if(!noRemove.includes(value.getAttribute('data-inputorder'))
                    ){

                        //Remove Element
                        value.remove();

                    }

                });

                return this.inputsdivs = [];

            },
            fileData(element){

                //Clean Variable
                this.filedataform = {};

                //Get Data from File
                let filedata = element.target.files[0];

                //Check fileSize
                if(filedata.size >= this.alertgigabyte){

                    alert('Please send a smaller file size');

                    //Disabled Submit button
                    this.disabled = true;

                    return;

                }

                //Check type of the file
                if(!filedata.type.includes('image')){

                    alert('Please only send image type file');

                    //Disabled Submit button
                    this.disabled = true;

                    return;

                }

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(filedata);
                reader.onload = e => {

                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                       
                        //Set File Width
                        this.filewidth = img.width;

                        //Set File Height
                        this.fileheight = img.height;

                        return this.filewidth, this.fileheight;

                    };

                    img.onerror = (error) => {
                        
                        throw new Error(error)

                    };

                    img.src = src;
                };

                //Show input file alt
                document.querySelector('.logotipoinputalt').classList.remove('d-none');

                //Check if readonly is active
                if(document.getElementById('filealt').hasAttribute('readonly')){

                    //Set Read Only
                    document.getElementById('filealt').removeAttribute('readonly');

                }

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(filedata);

                //Structure File Data Object
                this.filedataform = {
                    name: 'logotipo',
                    fileaction: this.formaction,
                    filename: filedata.name,
                    type: filedata.type.replace("image/", ""),
                    file64: ''
                };

                //Set Update Data
                if(this.formaction === 'update'){

                    let upddateData = {
                        id: element.target.parentElement.parentElement.getAttribute('data-idcolumn'),
                        //imageid: element.target.parentElement.parentElement.getAttribute('data-imageid'),
                        //typecolumn: element.target.parentElement.parentElement.getAttribute('data-typecolumn'),
                        //storagefile: element.target.parentElement.parentElement.getAttribute('data-storagefile')
                    };

                    //Check Attributes
                    if(element.target.parentElement.parentElement.hasAttribute('data-imageid')){

                        upddateData.imageid = element.target.parentElement.parentElement.getAttribute('data-imageid');

                    }

                    //Check Attributes
                    if(element.target.parentElement.parentElement.hasAttribute('data-storagefile')){

                        upddateData.storagefile = element.target.parentElement.parentElement.getAttribute('data-storagefile');

                    }

                    this.filedataform.updatedata = upddateData;

                }

                //Get Data from Promise
                file64Promise.then((val64) => {

                    //Set file64
                    this.filedataform.file64 = val64;

                    return this.filedataform;

                }).catch((error) => {

                    throw new Error(error);

                });

            },
            styleFileData(element){

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Disabled Input
                document.getElementById('layoutfile').setAttribute('disabled', true);

                //Clean Variable
                this.stylefiledataform = {};

                //Get Data from File
                let filedata = element.target.files[0];

                //Check fileSize
                if(filedata.size >= this.alertgigabyte){

                    alert('Please send a smaller file size');

                    //Clean Input Value
                    document.getElementById('layoutfile').value = ''; 

                    return;

                }

                //Check type of the file
                if(filedata.type !== 'text/css' 
                ){

                    alert('Please only send css type file');

                    //Clean Input Value
                    document.getElementById('layoutfile').value = ''; 

                    return;

                }

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(filedata);

                //Structure File Data Object
                this.stylefiledataform = {
                    name: `Layout ${(this.layoutlist.length + 1)}`,
                    classname: `layout-${(this.layoutlist.length + 1)}`,
                    filename: filedata.name,
                    type: filedata.type.replace("text/", ""),
                    file64: ''
                };

                //Get Data from Promise
                file64Promise.then((val64) => {

                    //Set file64
                    this.stylefiledataform.file64 = val64;

                    //Send Style FileData
                    let response = fetchData.structureTosendData(this.layoutfile, this.stylefiledataform, this.csrftolken, 'POST');
                    
                    //Check Response
                    response.then((value) => {

                        //Enabled Input
                        document.getElementById('layoutfile').removeAttribute('disabled');

                        //Clean Input Value
                        document.getElementById('layoutfile').value = ''; 

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Check Success Value
                        if(value.hasOwnProperty('attLayoutListData')){

                            //Set Layout List
                            this.layoutlist = value.attLayoutListData;

                            return;

                        }

                        //Check Error Message
                        if(value.hasOwnProperty('errorMessage')){

                            //Set Object Keys
                            let key = Object.keys(value);

                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key[0].toLowerCase());

                            //Element for append
                            let li = `<li class="list-group item my-1">${value.errorMessage[0]}</li>`;

                            //Append Element
                            $(li).appendTo(this.$refs.responsebasemessage.children);

                            //Remove Base Response Message
                            this.removeResponseMessages();

                            return;

                        }


                    }).catch((error) => {

                        //Enabled Input
                        document.getElementById('layoutfile').removeAttribute('disabled');

                        //Clean Input Value
                        document.getElementById('layoutfile').value = ''; 

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        throw new Error(error);

                    });

                }).catch((error) => {

                    throw new Error(error);

                });

                return;

            },
            inputValidationMethod(validationtype, inputvalue, inputid = ''){

                //Instance Validation
                let inputValidation = new validation(validationtype, '', '');

                //Validation Method
                let validInput;

                //Set Method
                switch(validationtype)
                {
                    //Input Validation only for numbers
                    case 2:

                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                      
                    break;

                    //Input Validation All Types of data
                    case 4:
                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                    break;

                    //Email Validation
                    case 7:

                        let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                        validInput = emailRegex.test(inputvalue);
                        
                    break;
                    
                    //URL Validation
                    case 8:
                        validInput = inputValidation.isValidUrl(inputvalue, inputid);
                    break;

                    //Input Validation only for numbers no white spaces
                    case 9:

                        validInput = inputValidation.validNameCases(7, inputvalue);
                      
                    break;

                }

                return validInput;

            },
            inputErrorsLoop(classname){

                //Data for submit
                let dataobject = [];
                 
                //Get Data from Inputs
                let allInputs = [...document.querySelectorAll(classname)];

                //Input Ids with Errors
                let listIdInputs = [];

                //Get only Values for Inputs
                allInputs.forEach((value, index) => {

                    //Get Childrens
                    let childrens = [...value.children];

                    //console.log(childrens);

                    //Only Get Input Element
                    if(childrens[1].nodeName === 'INPUT' ||
                        childrens[1].nodeName === 'TEXTAREA' && childrens[1].value !== ''
                    ){

                        //Set Validation type by name
                        let validationtype = 0;

                        switch(childrens[1].getAttribute('name')){

                            case 'morada':
                            case 'funcionamento':    
                                validationtype = 4;
                            break;

                            case 'email':
                                validationtype = 7;
                            break;

                            case 'phone':
                                validationtype = 2;
                            break;

                            case 'latitude':
                            case 'longetutide':
                            case 'zoommap':        
                                validationtype = 9;
                            break;

                            default:
                                validationtype = 8;
                            break;

                        }
                        
                        //Check only Input Data is not empty
                        if(childrens[1].value || childrens[1].value !== ""){

                            //console.log([classname, childrens[1].value]);

                            //Check Valid Input Data
                            if(this.inputValidationMethod(validationtype, childrens[1].value, childrens[1].getAttribute('id'))){

                                //Get Input Value and Refer
                                let inputData = {
                                    name: childrens[1].getAttribute('name'),
                                    value: childrens[1].value.trim()
                                };

                                //Push Data for send
                                dataobject.push(inputData);

                            }else{

                                //Set Inputs Ids for show error message
                                listIdInputs.push(childrens[1].getAttribute('id'));

                            }

                        }

                    }

                });

                //Set Update Data - Get Id from each Content Type
                if(this.formaction === 'update' && 
                document.querySelector(classname).parentElement.parentElement.hasAttribute('data-idcolumn')
                ){

                    let upddateData = {
                        id: document.querySelector(classname).parentElement.parentElement.getAttribute('data-idcolumn'),
                        //typecolumn: document.querySelector(classname).parentElement.parentElement.getAttribute('data-typecolumn')
                    };

                    dataobject.push(upddateData);

                }

                return [dataobject, listIdInputs];

            },
            dataStructureResponse(responseObject){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                try{

                    //Loop response conditional
                    for(const [key, value] of entries){

                        switch(key)
                        {

                            case 'attListData':

                                //Set New Att Datalist
                                this.alldata = Array.isArray(value[0]) ? value[0] : value;

                                //Check if exist old data
                                if(this.alldata.length > 0){

                                    //Set Update Form Action
                                    this.formaction = 'update';
                                    this.btntext = 'Update';

                                    //Clean Variables
                                    this.filedataform = {};
                                    this.filewidth = '';
                                    this.fileheight = '';

                                    //Check if the img exist
                                    if(document.querySelector('.logotiposhowimg')){

                                        //Remove Image Elements
                                        document.querySelector('.logotiposhowimg').remove();

                                    }

                                    //Set Input Data
                                    this.addDataForSetInputData(true);
                                
                                }

                                //Check Media Att Sequence
                                if(Array.isArray(value[1])){

                                    //Set New Values for Media List
                                    localStorage.setItem('medialist', JSON.stringify(value[1]));

                                    //Get All Media Data
                                    this.checkLocalStorage();

                                }


                            break;

                            case 'successMessage':
                            case 'errorMessage':
                                
                                //Add active Class
                                this.$refs.responsebasemessage.classList.add(this.activeclass);
                                this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                                //Set Messages List
                                value.forEach((valmessage) => {

                                    //Element for append
                                    let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                    //Append Element
                                    $(li).appendTo(this.$refs.responsebasemessage.children);

                                });
                                

                            break;

                        }

                    }

                    //Enabled BTN
                    this.disabled = false;

                    //Remove Base Response Message
                    this.removeResponseMessages();

                    return this.alldata;

                }catch(error){

                    throw new Error(error);

                }

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            sendData(formaction){

                //Disabled BTN
                this.disabled = true;

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Error Conditional
                let listIdFileAlt = [];

                //Structure Data Form
                let dataForm = {
                    socialmedia: {
                        data: [],
                        id: null
                    },
                    contacts: {
                        data: [],
                        id: null
                    },
                    layout: {},
                    headerlayout: {},
                    googlemaps: {
                        data: [],
                        id: null
                    },
                    googletag:{
                        data: [],
                        id: null
                    }
                }

                //Set Dynamic Values from Width and Height by image
                switch(this.filedataform.fileaction){

                    //Check Insert or Update
                    case formaction:

                        dataForm.logotipo = this.filedataform;
                        dataForm.logotipo.width = this.filewidth;
                        dataForm.logotipo.height = this.fileheight;
                        dataForm.logotipo.filealt = this.computedFileAlt !== '' ? this.computedFileAlt : dataForm.logotipo.type

                        //Check File Alt
                        if(!this.inputValidationMethod(4, dataForm.logotipo.filealt, 'filealt')){

                            listIdFileAlt.push('filealt');

                        }

                    break;

                    //Check Select
                    case 'select':

                        dataForm.logotipo = this.filedataform;

                    break;

                }
            
                //Check Errors and Get Data for Submit - Social Media
                let validateSocialMediaData = this.inputErrorsLoop('.socialmediainput');
                let errorsSocialMedia = validateSocialMediaData[1];
                dataForm.socialmedia.data = validateSocialMediaData[0];

                //Check Errors and Get Data for Submit - Contacts
                let validateContactData = this.inputErrorsLoop('.contactinput');
                let errorsContacts = validateContactData[1];
                dataForm.contacts.data = validateContactData[0];

                //Check Errors and Get Data for Submit - Contacts
                let validateGoogleMapsData = this.inputErrorsLoop('.googlemapsinput');
                let errorsGoogleMaps = validateGoogleMapsData[1];
                dataForm.googlemaps.data = validateGoogleMapsData[0];

                //Get Data for Google Tag 
                //dataForm.googletag.data = this.$refs.googletag_data.textContent.trim();
                dataForm.googletag.data.push(this.googletagcode);

                //Get Data for Submit - Layout
                dataForm.layout = {
                    name: "layout",
                    value: parseInt(document.querySelector('.layoutinput select').value.trim())
                };

                //Set layout Data
                let layoutSelected = this.layoutlist.find(value => parseInt(value.id) === parseInt(dataForm.layout.value));
                dataForm.layout.layoutname = layoutSelected.name;
                dataForm.layout.filenamenew = layoutSelected.data.filenamenew;

                //Get Others Layout Ids
                dataForm.layout.layoutidlist = this.layoutlist.filter(value => parseInt(value.id) !== parseInt(dataForm.layout.value));

                //Get Data for Submit - HeaderLayout
                let headerlayout = {
                    name: "headerlayout",
                    selected: parseInt(document.querySelector('.headerlayoutinput select').value.trim())
                };

                //Set HeaderLayout Value
                headerlayout.value = this.headerlayoutlist.find(value => parseInt(value.id) === parseInt(headerlayout.selected));

                //Set Object
                dataForm.headerlayout = headerlayout;

                //console.log(dataForm);

                //Check Routine for Layout | HeaderLayout
                if(formaction === "update"){

                    //Add Id for content default sections
                    dataForm.socialmedia.id = document.querySelector('.socialmedia').hasAttribute('data-idcolumn') ? 
                    parseInt(document.querySelector('.socialmedia').getAttribute('data-idcolumn')) : null;
                    dataForm.contacts.id = document.querySelector('.contatos').hasAttribute('data-idcolumn') ? 
                    parseInt(document.querySelector('.contatos').getAttribute('data-idcolumn')) : null;
                    dataForm.googlemaps.id = document.querySelector('.googlemaps').hasAttribute('data-idcolumn') ? 
                    parseInt(document.querySelector('.googlemaps').getAttribute('data-idcolumn')) : null;
                    dataForm.googletag.id = document.querySelector('.googletag').hasAttribute('data-idcolumn') ? 
                    parseInt(document.querySelector('.googletag').getAttribute('data-idcolumn')) : null;

                    //Check Layout Routine
                    if(parseInt(this.activelayoutid) !== parseInt(dataForm.layout.value)){

                        //Set Id Column
                        dataForm.layout.id = parseInt(document.querySelector('.layout').getAttribute('data-idcolumn'));

                        //Check Error
                        if(dataForm.layout.value === "" || !Number.isInteger(parseInt(dataForm.layout.value))){

                            //Send Error Message
                            listIdInputs.push(document.querySelector('.layoutinput').getAttribute('id'));

                        }

                    }else{

                        //Remove Data
                        delete dataForm.layout;

                    }

                    //Check HeaderLayout Routine
                    if(parseInt(this.activeheaderlayoutid) !== parseInt(dataForm.headerlayout.selected)){

                        //Set Id Column
                        dataForm.headerlayout.id = parseInt(document.querySelector('.headerlayout').getAttribute('data-idcolumn'));

                        //Check Error
                        if(dataForm.headerlayout.selected === "" || !Number.isInteger(parseInt(dataForm.headerlayout.selected))){

                            //Send Error Message
                            listIdInputs.push(document.querySelector('.headerlayoutinput').getAttribute('id'));

                        }

                    }else{

                        //Remove Data
                        delete dataForm.headerlayout;

                    }

                    //console.log(dataForm);

                }
              
                //Merge errors
                let listIdInputs = errorsSocialMedia.concat(errorsContacts, listIdFileAlt, errorsGoogleMaps);

               //Show Error Messages
                if(listIdInputs.length > 0){

                    //console.log(listIdInputs);

                    //Set id for error message
                    listIdInputs.forEach((value) => {

                        //Instance Validation
                        let inputValidation = new validation(3, '', '');

                        //Set Uppercase
                        let firstLetter = value.at(0).toUpperCase();
                        let capitalizaValue = value.replace(value.at(0), firstLetter);

                        //Render Erro Message
                        inputValidation.createErrorMessageElement(value, `Please inform the correct format for ${capitalizaValue}`);

                    });

                    //Clean Error Message
                    setTimeout(function(){

                        //Clean all Error Messages
                        [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                            //Remove element
                            value.remove();

                        });

                    }, 5000);

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Disabled Submit
                    //return this.disabled = true;
                    return;

                }
                
                //Set Route
                let method;
                let urlmethod; 

                switch(formaction)
                {

                    case 'insert':

                        method = 'POST';
                        urlmethod = this.contentcreate;

                    break;

                    case 'update':

                        method = 'PUT';
                        urlmethod = this.contentupdate;

                    break;

                    /* case 'active':

                        method = 'PUT';
                        urlmethod = this.pageactive;

                    break; */


                }

                //Debug
                /* console.log(dataForm);
                return; */

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);
                
                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                    throw new Error(error);

                })

            }

        },
        computed:{

            computedInputsDivs(){

                return this.inputsdivs;

            },
            computedAllData(){

                return this.alldata;

            },
            computedFileWidth(){

                return this.filewidth; 

            },
            computedFileHeight(){

                return this.fileheight; 

            },
            computedFormAction(){

                return this.formaction;

            },
            computedBtnText(){

                return this.btntext;

            },
            computedFileAlt(){

                return this.filealt;

            },
            computedLayoutId(){

                return this.activelayoutid;

            },
            computedFiledataForm(){

                return this.filedataform;

            },
            computedCounter(){

                return this.counter;

            },
            computedAllMediaFiles(){

                return this.allmediafiles; 

            },
            computedActiveLayout(){

                return this.activelayoutid;

            },
            computedHeaderList(){

                return this.headerlayoutlist;

            },
            computedActiveHeaderLayout(){

                return this.activeheaderlayoutid;

            },
            computedLayoutList(){

                return this.layoutlist;

            }

        },
        watch:{
        
            computedInputsDivs(){},
            computedAllData(){},
            computedFileWidth(){},
            computedFileHeight(){},
            computedFormAction(){},
            computedBtnText(){},
            computedFileAlt(){},
            computedLayoutId(){},
            computedFiledataForm(){},
            computedCounter(){},
            computedAllMediaFiles(){},
            computedActiveLayout(){},
            computedHeaderList(){},
            computedActiveHeaderLayout(){},
            computedLayoutList(){}
        
        },
        components:{

            listMessage: ListMessage,
            loading: Loading,
            modal: Modal,
            mediaList: MediaList,
            insertMedia: InsertMedia

        }


    }

</script>